import styled from 'styled-components';

export const DzoneWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  .grid-list {
    display: grid;
    grid-gap: 20px;
    &--3 {
      grid-template-columns: 1fr 1fr 1fr;
    }
    &--5 {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
  }

  .buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .error {
    color: ${({ theme }) => theme.colors.error};
    font-size: 14px;
    font-weight: 500;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .grid-list {
      grid-gap: 10px;
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    .grid-list {
      &--3 {
        grid-template-columns: 1fr;
      }
      &--5 {
        grid-template-columns: 1fr;
      }
    }
  }
`;

export const Dropzone = styled.div`
  position: relative;
  border: 2px dashed ${({ theme }) => theme.colors.stroke};
  border-radius: 5px;
  text-align: center;
  padding: 0 20px;
  height: 170px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.cultured};
  &:hover {
    background-color: ${({ theme }) => theme.colors.stroke};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 30px 10px;
  }
`;
